export const environment = {
  production: true,
  authApiUrl: 'https://core-api.elearn.vn',
  coreApiUrl: 'https://core-api.elearn.vn',
  userID: JSON.parse(localStorage.getItem('userId'))
};
// check deploy
